module.exports = __webpack_public_path__ + "img/7.045b4ae1.png";